module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.8073ba79.png";